import '../jnanabhumi.css';


function PublicFooter() {


    return (
        <>
            <div className='affl-footer1 text-white'>
                <p className='mb-0'>Designed and Developed by </p>
                <p className='mb-0'><a href='https://apcfss.in/' target='_blank'><img src='../img/footer-logo.png' alt='' className='img-fluid' /></a></p>
            </div>
        </>
    );

}
export default PublicFooter;
